var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    clipPath: "url(#clip0_5146_14025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2358 76.7363H12.7716C11.8707 76.7363 11.1406 77.468 11.1406 78.3673C11.1406 79.2666 11.8707 79.9982 12.7716 79.9982H68.2342C69.1368 79.9982 69.8651 79.2682 69.8651 78.3673C69.8651 77.4664 69.1368 76.7363 68.2342 76.7363H68.2358Z",
    fill: "#192F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.869 69.9073H61.0264V13.3563C61.0264 12.7922 60.736 12.2679 60.2549 11.9692L41.3603 0.245557C41.3437 0.235602 41.3254 0.232283 41.3088 0.223987C41.211 0.167576 41.1064 0.121119 40.9969 0.0862766C40.9654 0.0746625 40.9339 0.0663666 40.9023 0.0564116C40.7729 0.0248875 40.6402 0 40.5008 0C40.3615 0 40.2287 0.0232283 40.0977 0.0564116C40.0645 0.0663666 40.0346 0.0763216 40.0031 0.0862766C39.8936 0.121119 39.789 0.167576 39.6912 0.223987C39.6746 0.233942 39.6563 0.237261 39.6397 0.245557L20.7435 11.9709C20.264 12.2695 19.972 12.7938 19.972 13.3579V69.909H2.13096C1.23003 69.909 0.5 70.639 0.5 71.5399C0.5 72.4408 1.23003 73.1709 2.13096 73.1709H78.8674C79.77 73.1709 80.4983 72.4392 80.4983 71.5399C80.4983 70.6406 79.77 69.909 78.8674 69.909L78.869 69.9073ZM38.8699 69.9073H23.2372V14.2638L38.8699 4.56437V69.909V69.9073ZM42.1318 69.9073V64.2147L51.307 69.9073H42.1318ZM57.7645 69.9073H57.494L42.1318 60.3754V54.273L57.7645 63.9725V69.9056V69.9073ZM57.7645 60.1331L42.1318 50.4337V44.3313L57.7645 54.0307V60.1331ZM57.7645 50.1914L42.1318 40.4919V34.3879L57.7645 44.089V50.1914ZM57.7645 40.2497L42.1318 30.5502V24.4461L57.7645 34.1456V40.2497ZM57.7645 30.308L42.1318 20.6068V14.5061L57.7645 24.2039V30.308ZM57.7645 20.3663L42.1318 10.6668V4.56437L57.7645 14.2638V20.3663Z",
    fill: "#192F51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_14025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.045bd2d6416f2705f89a54226d81a096.svg";
export { ForwardRef as ReactComponent };